import React from 'react';
import {connect} from 'react-redux';
import * as f2 from '../store/actions';
class App extends React.Component
{
	insert()
	{
		this.props.addnew(prompt("enter a title","topic"))
	}
	del(id)
	{
		this.props.del(id)
	}del1(id)
	{
		this.props.del1(id)
	}
	status(id)
	{
		this.props.status(id)
	}
	
	edit(ob)
	{
		 ob["name"]=prompt("new title",ob.name)
		this.props.edit(ob)
	}
	render()
	{
		let {a,option}=this.props
		let p=a.filter(x=>x.status===false)
		let b=option!==null?(a.filter(x=>x.status===option)):a
		return (
				<div className="container">
					<h1 onClick={this.status.bind(this,null)}>All todos</h1>
					<button onClick={this.status.bind(this,false)} clasName="pending">pending {p.length}</button>
					<button onClick={this.status.bind(this,true)} clasName="completed">completed {a.length-p.length}</button>
					<button onClick={this.del1.bind(this,false)} clasName="pending">delete pending</button>
					<button onClick={this.del1.bind(this,true)} clasName="completed">delete completed</button>
					<button onClick={this.del1.bind(this,"all")} className="del">delete all</button>
					<button onClick={this.insert.bind(this)} className="add">add new todos</button>
					<ul>
						{b.map(x=>
							<li key={x.id} className={x.status?"active":""}>
								<div className="left">
									<span>{x.name}</span>
								</div>
								<div className="right">
									<button onClick={this.del.bind(this,x.id)}>delete</button>
									<button onClick={this.edit.bind(this,x)}>edit</button>
								</div>
						  </li>
						)}
					</ul>
				</div>

			)	
	}
}
export default connect(state=>state,f2)(App);